import { CriticalityBadge, ActorName } from './chunk-U7NLNKTV.js';
import { cn } from './chunk-FFX3LZW7.js';
import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
import { formatRelativeTime } from '@authe/fe-commons/time';

function groupByDay(events) {
  const map = /* @__PURE__ */ new Map();
  for (const event of events) {
    const day = event.created_at?.slice(0, 10) ?? "Unknown";
    const bucket = map.get(day) ?? [];
    bucket.push(event);
    map.set(day, bucket);
  }
  return [...map.entries()].sort(([a], [b]) => b.localeCompare(a));
}
function timeOfDay(iso) {
  if (!iso) return "";
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return iso;
  return date.toLocaleTimeString(void 0, { hour: "2-digit", minute: "2-digit" });
}
function AuditTrail({ events, className, renderActions }) {
  const grouped = groupByDay(events);
  return /* @__PURE__ */ jsx("div", { className: cn("flex flex-col gap-6", className), children: grouped.map(([day, bucket]) => /* @__PURE__ */ jsxs("section", { className: "space-y-2", children: [
    /* @__PURE__ */ jsx("h3", { className: "text-xs font-semibold uppercase tracking-wide text-muted-foreground", children: day }),
    /* @__PURE__ */ jsx("ol", { className: "space-y-3 border-l pl-4", children: bucket.map((event) => {
      const criticality = event.criticality_level;
      return /* @__PURE__ */ jsxs("li", { className: "relative", children: [
        /* @__PURE__ */ jsx("span", { className: "absolute -left-[1.4rem] top-1.5 inline-flex size-2 rounded-full bg-brand" }),
        /* @__PURE__ */ jsxs("div", { className: "flex items-start justify-between gap-3 rounded-md border bg-card p-3 shadow-xs", children: [
          /* @__PURE__ */ jsxs("div", { className: "flex flex-col gap-1", children: [
            /* @__PURE__ */ jsxs("div", { className: "flex items-center gap-2", children: [
              /* @__PURE__ */ jsx(CriticalityBadge, { level: criticality }),
              /* @__PURE__ */ jsx("span", { className: "font-medium", children: event.function_name ?? event.resource })
            ] }),
            /* @__PURE__ */ jsx("p", { className: "text-sm text-muted-foreground", children: event.message_summary }),
            event.payload_summary && /* @__PURE__ */ jsx("p", { className: "text-xs text-muted-foreground", children: event.payload_summary }),
            /* @__PURE__ */ jsxs("span", { className: "text-xs text-muted-foreground", children: [
              /* @__PURE__ */ jsx("time", { dateTime: event.created_at, title: event.created_at, children: timeOfDay(event.created_at) }),
              event.created_by && /* @__PURE__ */ jsxs(Fragment, { children: [
                " \xB7 by ",
                /* @__PURE__ */ jsx(ActorName, { id: event.created_by })
              ] })
            ] })
          ] }),
          renderActions && /* @__PURE__ */ jsx("div", { children: renderActions(event) })
        ] })
      ] }, event.id);
    }) })
  ] }, day)) });
}
function AuditTimestamp({ value, unit = "milliseconds", relative = false }) {
  const date = value == null || value === "" ? null : new Date(typeof value === "number" && unit === "seconds" ? value * 1e3 : value);
  if (!date || !Number.isFinite(date.getTime())) return /* @__PURE__ */ jsx(Fragment, { children: "Not recorded" });
  return /* @__PURE__ */ jsx("time", { dateTime: date.toISOString(), title: date.toLocaleString(), children: relative ? formatRelativeTime(date.getTime(), { unit: "milliseconds" }) : date.toLocaleString() });
}
function ResourceAuditMetadata({
  createdBy,
  createdAt,
  updatedBy,
  updatedAt,
  names,
  createdLabel = "Created by",
  showUpdated = true,
  className,
  title,
  unit,
  relative
}) {
  return /* @__PURE__ */ jsxs("span", { className, title, children: [
    createdLabel,
    " ",
    /* @__PURE__ */ jsx(ActorName, { id: createdBy, names }),
    " \xB7 ",
    /* @__PURE__ */ jsx(AuditTimestamp, { value: createdAt, unit, relative }),
    showUpdated && /* @__PURE__ */ jsxs(Fragment, { children: [
      " \xB7 Last edited by ",
      /* @__PURE__ */ jsx(ActorName, { id: updatedBy, names }),
      " \xB7 ",
      /* @__PURE__ */ jsx(AuditTimestamp, { value: updatedAt, unit, relative })
    ] })
  ] });
}

export { AuditTimestamp, AuditTrail, ResourceAuditMetadata };
//# sourceMappingURL=chunk-QOPNK4WR.js.map
//# sourceMappingURL=chunk-QOPNK4WR.js.map